import { isApiError } from '@/shared/api';
import { getStatusEntry } from '@/shared/api';
import { safeT } from '@/shared/localization';
import type { Translator } from '@/shared/localization';
import { logger } from '@/shared/logger';

export type ErrorInfo = { status: number | 'default'; message: string };

// 키가 메시지에 없으면 'status.unknown' 으로 폴백한다.
// status.${code} / code.${i18nKey} 처럼 런타임에 조립되는 동적 키라 메시지 키 유니온으로
// 좁혀지지 않는다. safeT 가 t.has 로 런타임 가드한 뒤 폴백을 반환한다.
function translateOrUnknown(t: Translator<'error'>, key: string): string {
  return safeT(t, key, t('status.unknown'));
}

// t 는 'error' 네임스페이스로 스코프된 translator 라고 가정한다(ErrorFallback 참조).
export function getErrorInfo(error: Error, t: Translator<'error'>): ErrorInfo {
  try {
    if (isApiError(error)) {
      // error 페이지는 status 기반으로 처리
      const statusCode = error.status;
      const entry = getStatusEntry(statusCode);
      if (entry?.i18nKey) {
        const codeKey = `code.${entry.i18nKey}`;
        return {
          status: statusCode,
          message: translateOrUnknown(t, codeKey),
        };
      }

      const statusKey = `status.${statusCode}`;
      return {
        status: statusCode,
        message: translateOrUnknown(t, statusKey),
      };
    }
  } catch (err) {
    logger.error({ err }, '[getErrorInfo] failed to resolve error info');
  }

  return {
    status: 'default',
    message: t('status.unknown'),
  };
}
